import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { siteConfig } from "@/lib/data";
import { useTranslation } from "react-i18next";

export default function TermsOfServicePage() {
  const { t } = useTranslation();
  return (
    <>
      <Helmet>
        <title>Terms of Service | {siteConfig.name}</title>
        <meta name="description" content="Syarat dan Ketentuan layanan PT. Naincode Inti Technology. Ketentuan penggunaan layanan teknologi kami." />
        <link rel="canonical" href={`${siteConfig.url}/terms-of-service`} />
      </Helmet>
      
      <section className="pt-32 pb-32 relative z-10">
      <div className="section-container section-padding">
        <div className="max-w-3xl mx-auto">
          <Link to="/" className="inline-flex items-center gap-2 text-white/50 hover:text-neon-400 transition-colors mb-8">
            <ArrowLeft className="w-4 h-4" />
            {t('home.terms_page.btn_back')}
          </Link>

          <h1 className="text-3xl md:text-4xl font-bold gradient-text-white mb-8">
            {t('home.terms_page.title')}
          </h1>

          <div className="prose prose-invert max-w-none">
            <p className="text-white/50 mb-6">
              {t('home.terms_page.last_updated')}
            </p>

            {((t('home.terms_page.content', { returnObjects: true }) || []) as any[]).map((section, idx) => (
              <div key={idx}>
                <h2 className="text-xl font-semibold text-white mt-8 mb-4">{section.title}</h2>
                <div 
                  className="text-white/50 leading-relaxed mb-4"
                  dangerouslySetInnerHTML={{ __html: section.desc }}
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
    </>
  );
}
